// ======================================================================
// File Name       : EmailAction
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import _ from 'lodash';
import { RETURN_MAX_NUM_1000, SELECT_TARGET_DATA } from '../constants';
import { MAIL_EDIT_TYPE, MAIL_SEND_STATUS } from '../constants/EmailConstants';
import * as ModalIds from '../constants/ModalIds';
import { USER_ATTRIBUTE_TYPE } from '../constants/UserAttributeConstants';
import * as UserUtils from '../utils/UserUtils';
import * as emailActionCreators from './actionCreators/email';
import * as mailRequest from './httpRequests/email';
import * as groupRequests from './httpRequests/group';
import * as userRequests from './httpRequests/user';
import * as userAttributeRequests from './httpRequests/userAttribute';
import * as ModalAction from './ModalAction';
import * as userActions from './UserAction';
import { USER_CREATE_TYPE } from '../constants/UserConstants';

export function fetchGroupStructure(isGetAll) {
  return dispatch =>
    groupRequests
      .postGroupGetStructure(undefined, isGetAll)
      .then(({ groupList }) => {
        return dispatch(emailActionCreators.doReceiveGroupStructureList(groupList));
      });
}

export function initDataForRegisterDestinationUserDialog() {
  return (dispatch) => {
    dispatch(ModalAction.openModal(ModalIds.EMAIL_REGISTER_EDIT_USER));
  };
}

export function getAllUserAttribute({
  startPosition,
  returnMaxNum,
  userAttributeKeyNum,
  userAttributeSearchText,
  }) {
  return async (dispatch, getState) => {
    let position = 0;
    const filterData = {
      userAttributeType: USER_ATTRIBUTE_TYPE.USER,
      userAttributeKeyNum,
      userAttributeSearchText,
      returnMaxNum,
      startPosition,
    };

    let param = {
      searchInfo: filterData,
    };

    const requests = [];
    const res = await dispatch(getUserAttribute(param));
    if (res && res.data && res.data.recordNum > RETURN_MAX_NUM_1000) {
      let pager = Math.ceil(res.data.recordNum / RETURN_MAX_NUM_1000) - 1;
      while (pager > 0) {
        pager--;
        position += (RETURN_MAX_NUM_1000);

        // Update start position
        filterData.startPosition = position;
        param = { searchInfo: filterData };
        requests.push(dispatch(getUserAttribute(param)));
      }
    }
    await Promise.all(requests);
  };
}

export function getUserAttribute(searchInfo = {}) {
  return async (dispatch) => {
    const data = await userAttributeRequests.postUserAttributeGetList(searchInfo);
    return dispatch(emailActionCreators.allUserAttributeReceived(data));
  };
}

export function getAllUserGroupRelation({
  searchInfo,
}) {
  return async (dispatch, getState) => {
    const requests = [];
    let position = 0;
    const param = {
      searchInfo,
    };
    const res = await dispatch(getUserGroupRelation(param));
    if (res && res.data && res.data.recordNum > RETURN_MAX_NUM_1000) {
      let pager = Math.ceil(res.data.recordNum / RETURN_MAX_NUM_1000) - 1;
      while (pager > 0) {
        pager--;
        position += (RETURN_MAX_NUM_1000);

        // Update start position
        param.searchInfo.startPosition = position;
        requests.push(dispatch(getUserGroupRelation(param)));
      }
    }
    await Promise.all(requests);

  };
}

export function getUserGroupRelation(searchInfo = {}) {
  return async (dispatch) => {
    const data = await groupRequests.postUserGroupRelationGetList(searchInfo);
    return dispatch(emailActionCreators.allUserGroupRelationReceived(data));
  };
}

export function getAllUserList({
  searchInfo,
}) {
  return async (dispatch, getState) => {
    let position = 0;
    const param = {
      searchInfo,
      selectTargetData: SELECT_TARGET_DATA.DATA,
    };
    const requests = [];
    const res = await dispatch(getUserList(param));
    if (res && res.data && res.data.recordNum > RETURN_MAX_NUM_1000) {
      let pager = Math.ceil(res.data.recordNum / RETURN_MAX_NUM_1000) - 1;
      while (pager > 0) {
        pager--;
        position += (RETURN_MAX_NUM_1000);

        // Update start position
        param.searchInfo.startPosition = position;
        requests.push(dispatch(getUserList(param)));
      }
    }
    await Promise.all(requests);
  };
}

export function getUserList(searchInfo = {}) {
  return async (dispatch) => {
    const data = await userRequests.postUserGetList(searchInfo);
    return dispatch(emailActionCreators.allUserListReceived(data));
  };
}

export function getAllGroupRelation({
  searchInfo,
}) {
  return async (dispatch, getState) => {
    let position = 0;
    const param = {
      searchInfo,
    };
    const requests = [];
    const res = await dispatch(getGroupRelation(param));
    if (res && res.data.recordNum && res.data.recordNum > RETURN_MAX_NUM_1000) {
      let pager = Math.ceil(res.data.recordNum / RETURN_MAX_NUM_1000) - 1;
      while (pager > 0) {
        pager--;
        position += (RETURN_MAX_NUM_1000);

        // Update start position
        param.searchInfo.startPosition = position;
        requests.push(dispatch(getGroupRelation(param)));
      }
    }
    await Promise.all(requests);
  };
}

export function getGroupRelation(searchInfo = {}) {
  return async (dispatch) => {
    const data = await groupRequests.postUserGroupRelationGetList(searchInfo);
    return dispatch(emailActionCreators.allGroupRelationReceived(data));
  };
}

export function getAllUser({
  startPosition,
  returnMaxNum,
  userName,
  loginId,
  dormantState,
  selectedGroupList,
  userAttributeKeyNum,
  userAttributeSearchText,
}) {
  return async (dispatch, getState) => {
    let userGroupSecernIds = {};
    let groupRelationList = {};
    let searchInfo = {};
    let isAttr = false;
    if (userAttributeSearchText) {
      isAttr = true;
      await dispatch(getAllUserAttribute({ startPosition: 0, returnMaxNum, userAttributeKeyNum, userAttributeSearchText }));
    }
    const userAttributeSecernIds = await getState().email.allUserAttribute;
    if (!userAttributeSecernIds.length && isAttr) {
      return dispatch(emailActionCreators.doReceiveAllUserSearchResult(startPosition, 0, [], userAttributeSearchText));
    }

    // Step 1. Get userSecernId list by selected group (selected group is OR condition)
    if (selectedGroupList && Object.keys(selectedGroupList).length > 0) {
      searchInfo = {
        startPosition: 0,
        groupList: selectedGroupList,
      };

      // get all user group relation list
      await dispatch(getAllUserGroupRelation({ searchInfo }));
      userGroupSecernIds = await getState().email.allUserGroupRelation;
    }
    // Step 2. Get user info by userSecernId list got from Step.1
    searchInfo = {
      startPosition: 0,
    };

    searchInfo.userName = userName;
    loginId && (searchInfo.loginId = loginId);
    searchInfo.startPosition = startPosition;
    searchInfo.returnMaxNum = returnMaxNum;
    searchInfo.dormantState = dormantState ? null : 0;
    searchInfo.userSecernIdList = getUserSecernIdList(selectedGroupList, userAttributeSecernIds, userGroupSecernIds);
    if (searchInfo.userSecernIdList.length === 0) { // When userSecernIdList is empty, set search condition to return no data
      searchInfo.userSecernIdList = userAttributeSecernIds;
      searchInfo.groupList = selectedGroupList;
    }
    searchInfo.userCreateType = USER_CREATE_TYPE.DEFINED_AND_REPRESENTATIVE_USER;

    // Get all user list
    await dispatch(getAllUserList({ searchInfo }));
    const userList = await getState().email.allUserList;
    const recordNum = Object.keys(userList);
    if (!userList || !userList.length) {
      return dispatch(emailActionCreators.doReceiveAllUserSearchResult(startPosition, recordNum, userList, userAttributeSearchText));
    }

    // Step 3. Get relation group from userList got from Step.2
    searchInfo = {
      startPosition: 0,
      userList: userList.map(({ userSecernId }) => userSecernId),
    };

    // Get all userGroupRelationList
    await dispatch(getAllGroupRelation({ searchInfo }));
    groupRelationList = await getState().email.allGroupRelation;

    // Step 4. Map group name with group list by user
    const groupList = (await dispatch(userActions.getGroupList(undefined, true))).groupList;

    const groupListByUser = UserUtils.convertObjectToList(groupRelationList, 'userSecernId', 'groupSecernId');
    userList.map((user, index) => {
      const groupSecernIdList =
        groupListByUser[user.userSecernId] && groupListByUser[user.userSecernId].groupSecernId
          ? groupListByUser[user.userSecernId].groupSecernId
          : [];
      const nameGroup = UserUtils.convertGroupListIdToGroupName(groupSecernIdList, groupList);
      user.groupName = nameGroup;
      return user;
    });
    return dispatch(emailActionCreators.doReceiveAllUserSearchResult(startPosition, recordNum, userList, userAttributeSearchText));
  };
}

export function checkAllUser() {
  return async (dispatch, getState) => dispatch(emailActionCreators.checkAllUser());
}

export function searchUser({
  startPosition,
  returnMaxNum,
  userAttributeKeyNum,
  userAttributeSearchText,
  managementAuthoritySecernId,
  userName,
  loginId,
  dormantState,
  selectedGroupList,
}) {
  return async (dispatch, getState) => {
    let isAttr = false;
    let userGroupSecernIds = {};
    let groupRelationList = {};
    let searchInfo = {};

    if (userAttributeSearchText) {
      isAttr = true;
      await dispatch(getAllUserAttribute({ startPosition: 0, RETURN_MAX_NUM_1000, userAttributeKeyNum, userAttributeSearchText }));
    }

    const userAttributeSecernIds = await getState().email.allUserAttribute;
    if (!userAttributeSecernIds.length && isAttr) {
      return dispatch(emailActionCreators.doReceiveUserSearchResult(startPosition, 0, []));
    }

    // Step 1. Get userSecernId list by selected group (selected group is OR condition)
    if (selectedGroupList && Object.keys(selectedGroupList).length > 0) {
      searchInfo = {
        startPosition: 0,
        groupList: selectedGroupList,
      };

      // Get all user group relation list
      await dispatch(getAllUserGroupRelation({ searchInfo }));
      userGroupSecernIds = await getState().email.allUserGroupRelation;
    }

    // Step 2. Get user info by userSecernId list got from Step.1
    searchInfo = {
      startPosition: 0,
    };
    managementAuthoritySecernId && (searchInfo.managementAuthorityList = [managementAuthoritySecernId]);
    searchInfo.userName = userName;
    loginId && (searchInfo.loginId = loginId);
    searchInfo.startPosition = startPosition;
    searchInfo.returnMaxNum = returnMaxNum;
    searchInfo.dormantState = dormantState ? null : 0;
    searchInfo.userSecernIdList = getUserSecernIdList(selectedGroupList, userAttributeSecernIds, userGroupSecernIds);
    // Step 11.2.0 TAS-18009 START
    searchInfo.userCreateType = USER_CREATE_TYPE.DEFINED_AND_REPRESENTATIVE_USER;
    // Step 11.2.0 TAS-18009 END
    if (searchInfo.userSecernIdList.length === 0) { // When userSecernIdList is empty, set search condition to return no data
      searchInfo.userSecernIdList = userAttributeSecernIds;
      searchInfo.groupList = selectedGroupList;
    }

    const { recordNum, userList } = await userRequests.postUserGetList({ searchInfo });

    // Step 3. Get relation group from userList got from Step.2
    searchInfo = {
      startPosition: 0,
      userList: userList.map(({ userSecernId }) => userSecernId),
    };

    const userGroupRelationList = await groupRequests.postUserGroupRelationGetList({ searchInfo });
    groupRelationList = userGroupRelationList.groupRelationList;

    // Step 4. Map group name with group list by user
    const groupList = (await dispatch(userActions.getGroupList(undefined, true))).groupList;

    const groupListByUser = UserUtils.convertObjectToList(groupRelationList, 'userSecernId', 'groupSecernId');
    userList.map((user, index) => {
      const groupSecernIdList =
        groupListByUser[user.userSecernId] && groupListByUser[user.userSecernId].groupSecernId
          ? groupListByUser[user.userSecernId].groupSecernId
          : [];
      const nameGroup = UserUtils.convertGroupListIdToGroupName(groupSecernIdList, groupList);
      user.groupName = nameGroup;
      return user;
    });
    return dispatch(emailActionCreators.doReceiveUserSearchResult(startPosition, recordNum, userList));
  };
}

function getUserSecernIdList(selectedGroupList, userAttributeSecernIds, userGroupSecernIds) {
  let userSecernIdList = [];
  if (userAttributeSecernIds && Object.keys(userAttributeSecernIds).length > 0) {
    userSecernIdList = userAttributeSecernIds;
  }

  if (selectedGroupList && Object.keys(selectedGroupList).length > 0
      && userGroupSecernIds && Object.keys(userGroupSecernIds).length > 0) {
    userSecernIdList = userGroupSecernIds;
  }

  if (userAttributeSecernIds && Object.keys(userAttributeSecernIds).length > 0
      && userGroupSecernIds && Object.keys(userGroupSecernIds).length > 0
      && selectedGroupList && Object.keys(selectedGroupList).length > 0) {
    const userAttributeSecernIdsArr = [userAttributeSecernIds][0];
    const userGroupSecernIdsArr = [userGroupSecernIds][0];
    userSecernIdList = _.intersection(userAttributeSecernIdsArr, userGroupSecernIdsArr);
  }
  return userSecernIdList;
}

export function addRemoveUser(userSecernId) {
  return emailActionCreators.addRemoveUser(userSecernId);
}

export function addRemoveAllUser() {
  return emailActionCreators.addRemoveAllUser();
}

export function addSelectedUser() {
  return emailActionCreators.addSelectedUser();
}

export function removeUser(userSecernId) {
  return emailActionCreators.removeUser(userSecernId);
}

export function removeAllUser() {
  return emailActionCreators.removeAllUser();
}

export function editingUserSearchCondition(payload) {
  return emailActionCreators.doReceiveSearchCondition(payload);
}

export function addGroup(group) {
  return emailActionCreators.addGroup(group);
}

export function removeGroup(index) {
  return emailActionCreators.removeGroup(index);
}

export function removeSelectedUser() {
  return emailActionCreators.removeSelectedUser();
}

export function resetInitData() {
  return emailActionCreators.resetInitData();
}

export function resetSearchUserData() {
  return emailActionCreators.resetSearchUserData();
}

export function resetSearchUserCondition() {
  return emailActionCreators.resetSearchUserCondition();
}

export function getEmailList(param) {
  return async (dispatch, getState) => {
    const mailListRes = await mailRequest.getEmailList(param);
    return dispatch(emailActionCreators.getEmailList(mailListRes));
  };
}

export function exportEmailCSV(param) {
  return async (dispatch, getState) => {
    const mailListRes = await mailRequest.getEmailList(param);
    return mailListRes;
  };
}

export function getEmailDetail(emailInfo) {
  return (dispatch, getState) => {
    dispatch(emailActionCreators.getEmailDetail(emailInfo));
  };
}

export function openGroupSelectDialog() {
  return (dispatch, getState) => {
    dispatch(ModalAction.openModal(ModalIds.SELECT_GROUP_MODAL_PARTICIPANT));
  };
}

export function showMailDetailDialog() {
  return (dispatch, getState) => {
    dispatch(ModalAction.openModal(ModalIds.EMAIL_DETAIL_DIALOG));
  };
}

export function getDataForEdit(emailSenderIdAuto) {
  return async (dispatch, getState) => {
    let position = 0;
    let userListToAdd = [];

    const filterData = {};
    filterData.emailSenderList = [parseInt(emailSenderIdAuto, 10)];
    filterData.emailSendStatusList = [MAIL_SEND_STATUS.RESERVED];
    filterData.returnMaxNum = RETURN_MAX_NUM_1000;
    filterData.startPosition = position;

    const param = {
      selectTargetData: SELECT_TARGET_DATA.DATA,
      searchInfo: filterData,
    };

    const requests = [];
    const res = await dispatch(getEditUserList(param));
    if (res && res.recordNum && res.recordNum > RETURN_MAX_NUM_1000) {
      let pager = Math.ceil(res.recordNum / RETURN_MAX_NUM_1000) - 1;
      while (pager > 0) {
        pager--;
        position += (RETURN_MAX_NUM_1000);

        // Update start position
        param.searchInfo.startPosition = position;
        requests.push(dispatch(getEditUserList(param)));
      }
    }
    await Promise.all(requests);
    userListToAdd = getState().email.allUserByEmail;
    return dispatch(
      emailActionCreators.addUsersToListByEmail(userListToAdd),
    );
  };
}

export function getEditUserList(param = {}) {
  return async (dispatch) => {
    const { recordNum, emailList } = await mailRequest.getEmailList(param);
    const emailIds = emailList.reduce((acc, cur) => {
      if (cur.receiverUserSecernId) {
        acc.push(cur.receiverUserSecernId);
        return acc;
      }
    }, []);

    const searchInfo = {};
    searchInfo.userSecernIdList = emailIds;

    const { userList } = await userRequests.postUserGetList({ searchInfo });
    return dispatch(emailActionCreators.allUserReceived(emailList, userList, recordNum));
  };
}

export function getReservedEmailDetailForEdit(param) {
  return async (dispatch, getState) => {
    const res = await mailRequest.postReservedEmailList(param);
    return dispatch(
      emailActionCreators.getReservedEmailDetailForEdit(res),
    );
  };
}

export function saveReceiver(param) {
  return async (dispatch, getState) => {
    const { emailReceiverList } = param;
    let start = 0;
    let end = 0;
    let emailReceiverListNew;

    const recordNum = emailReceiverList.length;
    let pager = Math.ceil(recordNum / RETURN_MAX_NUM_1000);

    emailReceiverListNew = emailReceiverList;
    if (pager > 1) {
      end = RETURN_MAX_NUM_1000;
      emailReceiverListNew = emailReceiverList.slice(start, end);
      pager--;
    }
    let searchInfo = {
      editType: MAIL_EDIT_TYPE.REGISTER,
      emailReceiverInfo: {
        emailReceiverList: emailReceiverListNew,
      },
    };

    await dispatch(getEmailReceiverSaveKey(searchInfo));
    const receiverSaveKey = getState().email.emailReceiverSaveKey;
    while (pager > 0) {
      pager--;
      start = end;
      end += RETURN_MAX_NUM_1000;
      end = end > recordNum ? recordNum : end;

      emailReceiverListNew = emailReceiverList.slice(start, end);

      searchInfo = {
        editType: MAIL_EDIT_TYPE.EDIT,
        emailReceiverInfo: {
          emailReceiverList: emailReceiverListNew,
          emailReceiverSaveKey: receiverSaveKey,
        },
      };

      await dispatch(getEmailReceiverSaveKey(searchInfo));
    }

    return receiverSaveKey;
  };
}

export function getEmailReceiverSaveKey(searchInfo = {}) {
  return async (dispatch) => {
    const result = await mailRequest.postSaveReceiver(searchInfo);
    return dispatch(emailActionCreators.saveReceiver(result));
  };
}

export function registerEditMail(editType, param) {
  return async (dispatch) => {
    try {
      await mailRequest.postEmailEdit(editType, param);
    } catch (error) {
      return error;
    }
  };
}

export function showReservedEmailConfirmDialog() {
  return (dispatch, getState) => {
    dispatch(ModalAction.openModal(ModalIds.RESERVED_EMAIL_CONFIRM_DIALOG));
  };
}

export function backupInitState() {
  return (dispatch, getState) => {
    dispatch(emailActionCreators.backupInitState());
  };
}

export function restoreInitState() {
  return (dispatch, getState) => {
    dispatch(emailActionCreators.restoreInitState());
  };
}

export function getUsersData(userSecernIdList) {
  return async (dispatch) => {
    let searchInfo = {};
    searchInfo.userSecernIdList = userSecernIdList;

    const { userList } = await userRequests.postUserGetList({ searchInfo });
    if (!userList || !userList.length) {
      return dispatch(emailActionCreators.receiveUsersFromCourseHistory(userList));
    }

    searchInfo = {
      startPosition: 0,
      userList: userList.map(({ userSecernId }) => userSecernId),
    };
    const { groupRelationList } = await groupRequests.postUserGroupRelationGetList({ searchInfo });
    if (!groupRelationList || !groupRelationList.length) {
      return dispatch(emailActionCreators.receiveUsersFromCourseHistory(userList));
    }

    const groupList = (await dispatch(userActions.getGroupList(undefined, true))).groupList;

    const groupListByUser = UserUtils.convertObjectToList(groupRelationList, 'userSecernId', 'groupSecernId');
    userList.map((user, index) => {
      const groupSecernIdList =
        groupListByUser[user.userSecernId] && groupListByUser[user.userSecernId].groupSecernId
          ? groupListByUser[user.userSecernId].groupSecernId
          : [];
      const nameGroup = UserUtils.convertGroupListIdToGroupName(groupSecernIdList, groupList);
      user.groupName = nameGroup;
      return user;
    });
    return dispatch(emailActionCreators.receiveUsersFromCourseHistory(userList));
  };
}

export function setUseTemplateData(courseDetail) {
  return (dispatch) => {
    const isUseTemplateData = 1;
    return dispatch(emailActionCreators.insertTemplateData(isUseTemplateData, courseDetail));
  };
}
